import { getLocaleCode, overrideCountryCode, } from '@root/src/web/lib/getCountryCode';
import { HIDE_SUPPORT_MESSAGING_COOKIE, RECURRING_CONTRIBUTOR_COOKIE, SUPPORT_ONE_OFF_CONTRIBUTION_COOKIE, SUPPORT_RECURRING_CONTRIBUTOR_ANNUAL_COOKIE, SUPPORT_RECURRING_CONTRIBUTOR_MONTHLY_COOKIE, } from '@root/src/web/lib/contributions';
import { setAlreadyVisited } from '@root/src/web/lib/alreadyVisited';
import { setCookie, getCookie, removeCookie, } from '@guardian/libs';
const readerRevenueCookies = [
    HIDE_SUPPORT_MESSAGING_COOKIE,
    RECURRING_CONTRIBUTOR_COOKIE,
    SUPPORT_RECURRING_CONTRIBUTOR_MONTHLY_COOKIE,
    SUPPORT_RECURRING_CONTRIBUTOR_ANNUAL_COOKIE,
    SUPPORT_ONE_OFF_CONTRIBUTION_COOKIE,
];
const clearEpicViewLog = () => localStorage.removeItem('gu.contributions.views');
const clearBannerLastClosedAt = () => {
    localStorage.removeItem('gu.prefs.engagementBannerLastClosedAt');
    localStorage.removeItem('gu.prefs.subscriptionBannerLastClosedAt');
    localStorage.removeItem('gu.noRRBannerTimestamp');
};
const fakeOneOffContributor = () => setCookie({
    name: SUPPORT_ONE_OFF_CONTRIBUTION_COOKIE,
    value: Date.now().toString(),
});
const MULTIVARIATE_ID_COOKIE = 'GU_mvt_id';
const MAX_CLIENT_MVT_ID = 1000000;
const incrementMvtCookie = () => {
    const mvtId = parseInt(getCookie({ name: MULTIVARIATE_ID_COOKIE }) || '10', 10);
    if (mvtId) {
        if (mvtId === MAX_CLIENT_MVT_ID) {
            // Wrap back to 1 if it would exceed the max
            setCookie({ name: MULTIVARIATE_ID_COOKIE, value: '1' });
        }
        else {
            setCookie({ name: MULTIVARIATE_ID_COOKIE, value: `${mvtId + 1}` });
        }
    }
};
const decrementMvtCookie = () => {
    const mvtId = parseInt(getCookie({ name: MULTIVARIATE_ID_COOKIE }) || '10', 10);
    if (mvtId) {
        if (mvtId === 0) {
            // Wrap back to max if it would be less than 0
            setCookie({
                name: MULTIVARIATE_ID_COOKIE,
                value: MAX_CLIENT_MVT_ID.toString(),
            });
        }
        else {
            setCookie({ name: MULTIVARIATE_ID_COOKIE, value: `${mvtId - 1}` });
        }
    }
};
const clearCommonReaderRevenueStateAndReload = (asExistingSupporter, shouldHideReaderRevenue) => {
    if (shouldHideReaderRevenue) {
        /* eslint-disable no-alert */
        alert('This page has "Prevent membership/contribution appeals" ticked in Composer. Please try a different page');
        /* eslint-enable no-alert */
        return;
    }
    readerRevenueCookies.forEach((cookie) => removeCookie({ name: cookie }));
    clearEpicViewLog();
    if (asExistingSupporter) {
        fakeOneOffContributor();
    }
    window.location.reload();
};
const showMeTheEpic = (asExistingSupporter = false, shouldHideReaderRevenue) => {
    clearCommonReaderRevenueStateAndReload(asExistingSupporter, shouldHideReaderRevenue);
};
const showMeTheBanner = (asExistingSupporter = false, shouldHideReaderRevenue) => {
    clearBannerLastClosedAt();
    setAlreadyVisited(2);
    clearCommonReaderRevenueStateAndReload(asExistingSupporter, shouldHideReaderRevenue);
};
const showNextVariant = (asExistingSupporter = false, shouldHideReaderRevenue) => {
    incrementMvtCookie();
    clearCommonReaderRevenueStateAndReload(asExistingSupporter, shouldHideReaderRevenue);
};
const showPreviousVariant = (asExistingSupporter = false, shouldHideReaderRevenue) => {
    decrementMvtCookie();
    clearCommonReaderRevenueStateAndReload(asExistingSupporter, shouldHideReaderRevenue);
};
const changeGeolocation = (asExistingSupporter = false, shouldHideReaderRevenue) => {
    getLocaleCode()
        .then((current) => {
        /* eslint-disable no-alert */
        const geo = window.prompt(`Enter two-letter geolocation code (e.g. GB, US, AU). Current is ${current}.`);
        if (geo === 'UK') {
            alert(`'UK' is not a valid geolocation - please use 'GB' instead!`);
        }
        else if (geo) {
            overrideCountryCode(geo);
            clearCommonReaderRevenueStateAndReload(asExistingSupporter, shouldHideReaderRevenue);
        }
        /* eslint-enable no-alert */
    })
        .catch((e) => console.error(`changeGeolocation - error: ${e}`));
};
const getForcedVariant = (type) => {
    if (URLSearchParams) {
        const params = new URLSearchParams(window.location.search);
        const value = params.get(`force-${type}`);
        if (value) {
            return value;
        }
    }
    return null;
};
export { changeGeolocation, showMeTheEpic, showMeTheBanner, showNextVariant, showPreviousVariant, getForcedVariant, };
